module.exports = __webpack_public_path__ + "static/tower.a292b599.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/tower/tower.png
// module id = 247
// module chunks = 0